import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const privacySchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://allchinabuy.art/privacy-policy#webpage",
  "url": "https://allchinabuy.art/privacy-policy",
  "name": "Privacy Policy — allchinabuy.art",
  "description": "allchinabuy.art is committed to protecting your privacy. This Privacy Policy explains how we handle information when you visit our website and use our AllChinaBuy Spreadsheet resources.",
  "inLanguage": "en-US",
  "isPartOf": {
    "@type": "WebSite",
    "@id": "https://allchinabuy.art/#website",
    "url": "https://allchinabuy.art/",
    "name": "allchinabuy.art"
  },
  "dateModified": "2026-06-25"
};

export default function PrivacyPolicy() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(privacySchema) }}
      />
      {/* Schema.org BreadcrumbList */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://allchinabuy.art/" },
              { "@type": "ListItem", "position": 2, "name": "Privacy Policy", "item": "https://allchinabuy.art/privacy-policy" }
            ]
          }),
        }}
      />
      <Navbar />
      <main>
        <section className="pt-24 pb-12 md:pt-32 md:pb-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors mb-6 cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">Privacy Policy</h1>
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-600 leading-relaxed space-y-4">
              <p>Last updated: June 2026</p>
              <p>
                allchinabuy.art is committed to protecting your privacy. This Privacy Policy explains how we handle information when you visit our website and use our AllChinaBuy Spreadsheet resources.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Information We Collect</h2>
              <p>
                We do not require user accounts, logins, or personal information to access our AllChinaBuy Spreadsheet. Our website may collect anonymized usage data through standard web analytics to help us understand how visitors interact with our content and improve the user experience.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">External Links</h2>
              <p>
                Our website contains links to external websites, including kaspreadsheet.com and various seller pages. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to review their respective privacy policies before providing any personal information.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Cookies</h2>
              <p>
                We may use essential cookies to ensure the proper functioning of our website. These cookies do not track personal information and are not used for advertising purposes. You can disable cookies in your browser settings if you prefer.
              </p>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Contact</h2>
              <p>
                If you have questions about this Privacy Policy, please refer to our <Link to="/about" className="text-primary-500 hover:text-primary-600 font-medium cursor-pointer">About page</Link> for more information about our project.
              </p>
            </div>
            <nav className="mt-8 text-xs text-foreground-400" aria-label="Breadcrumb">
              <ol className="flex items-center gap-2 flex-wrap">
                <li><Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">Home</Link></li>
                <li><i className="ri-arrow-right-s-line text-[10px]"></i></li>
                <li className="text-foreground-600">Privacy Policy</li>
              </ol>
            </nav>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}